import { Backdrop, CircularProgress, Container } from "@mui/material";
import background from "../assets/png/login-background.png";
import { ReactNode } from "react";

const ContainerLoadingLogin = ({
  loading = false,
  children,
}: {
  loading: boolean;
  children: ReactNode;
}) => {
  return (
    <Container component="main" maxWidth={false} sx={styles.container}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {children}
    </Container>
  );
};

const styles = {
  container: {
    background: `url(${background})`,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: { xs: 0 },
  },
};

export default ContainerLoadingLogin;
